function updateCart(updates) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ updates })
  }).then(() => {
    window.location.reload();
  });
}

function getBundleUpdates(bundleId, quantity) {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(cartItem => {
        if (
          cartItem.properties &&
          cartItem.properties._bundle_id === bundleId
        ) {
          updates[cartItem.key] = quantity;
        }
      });

      return updates;
    });
}

document.addEventListener('click', function(event) {
  const removeButton = event.target.closest('[data-remove-item]');
  if (!removeButton) return;

  const item = removeButton.closest('[data-input-item]');
  if (!item) return;

  const bundleId = item.dataset.bundleId;
  if (!bundleId) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  getBundleUpdates(bundleId, 0).then(updateCart);
}, true);

document.addEventListener('click', function(event) {
  const addButton = event.target.closest('[data-add-quantity]');
  const subtractButton = event.target.closest('[data-subtract-quantity]');

  if (!addButton && !subtractButton) return;

  const button = addButton || subtractButton;
  const item = button.closest('[data-input-item]');
  if (!item) return;

  const bundleId = item.dataset.bundleId;
  if (!bundleId) return;

  const input = item.querySelector('[data-quantity-input]');
  if (!input) return;

  const currentQuantity = parseInt(input.value, 10) || 1;
  const nextQuantity = addButton
    ? currentQuantity + 1
    : Math.max(currentQuantity - 1, 0);

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  getBundleUpdates(bundleId, nextQuantity).then(updateCart);
}, true);

document.addEventListener('change', function(event) {
  const input = event.target.closest('[data-quantity-input]');
  if (!input) return;

  const item = input.closest('[data-input-item]');
  if (!item) return;

  const bundleId = item.dataset.bundleId;
  if (!bundleId) return;

  const nextQuantity = Math.max(parseInt(input.value, 10) || 0, 0);

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  getBundleUpdates(bundleId, nextQuantity).then(updateCart);
}, true);
